module.exports = __webpack_public_path__ + "static/media/energy_card_yellow.bd7d99a4.svg";